var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{attrs:{"size":"sm","variant":"primary","to":_vm.path}},[_c('b-icon-arrow-left'),_vm._v(" "+_vm._s(_vm.text)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }